import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { MovementTrendDto } from '../types';
import { useChartColors } from '../hooks/useChartColors';

interface MovementTrendChartProps {
  data: MovementTrendDto[];
}

export function MovementTrendChart({ data }: MovementTrendChartProps) {
  const colors = useChartColors();
  // Format date for display
  const formattedData = data.map((item) => ({
    ...item,
    date: new Date(item.date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    }),
  }));

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Inventory Movement Trend</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={formattedData} margin={{ left: 0, right: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke={colors.border} />
              <XAxis dataKey="date" tick={{ fontSize: 11, fill: colors.muted }} stroke={colors.border} />
              <YAxis tick={{ fontSize: 11, fill: colors.muted }} stroke={colors.border} />
              <Tooltip
                contentStyle={{ fontSize: 12, backgroundColor: colors.card, border: `1px solid ${colors.border}`, borderRadius: 6, color: colors.foreground }}
                labelStyle={{ color: colors.foreground }}
                itemStyle={{ color: colors.foreground }}
              />
              <Legend wrapperStyle={{ fontSize: 12 }} formatter={(value) => <span style={{ color: colors.foreground }}>{value}</span>} />
              <Line
                type="monotone"
                dataKey="receivingQty"
                stroke={colors.success}
                name="Receiving"
                strokeWidth={2}
                dot={{ r: 3 }}
              />
              <Line
                type="monotone"
                dataKey="issuanceQty"
                stroke={colors.info}
                name="Issuance"
                strokeWidth={2}
                dot={{ r: 3 }}
              />
              <Line
                type="monotone"
                dataKey="adjustmentQty"
                stroke={colors.warning}
                name="Adjustment"
                strokeWidth={2}
                dot={{ r: 3 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
